import {readString} from 'react-papaparse';

import {
    MAX_RECORD_SIZE,
} from 'src/modules/search-criteria/components/recently-viewed/admin-tools/login-link-generator/constants';

export const parseLoginLinkGeneratorFile = (file: File): Promise<string[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
            if (event.target) {
                const fileContent = event.target.result as string;
                readString(fileContent, {
                    header: false,
                    dynamicTyping: true,
                    delimiter: ',',
                    skipEmptyLines: true,
                    quoteChar: '"',
                    complete: results => {
                        if (results.errors.length > 0) {
                            reject(results.errors);
                        } else {
                            const headers = (results.data as string[][])[0]
                                .map(header => (header === null ? '' : header))
                                .map((header: string) => header.toLowerCase())
                                .map((header: string) => header.trim());
                            const emailIndex = headers.indexOf('email');
                            if (emailIndex !== -1) {
                                const emails = (results.data as string[][]).slice(1)
                                    .map((row: string[]) => row[emailIndex])
                                    .filter(email => email !== null && email !== '')
                                    .map(email => email.toLowerCase());
                                resolve(emails);
                            } else {
                                reject(new Error(
                                    'File does not contain Email column. Please make sure the file matches the template',
                                ));
                            }
                        }
                    },
                });
            } else {
                reject(new Error('Event target is null.'));
            }
        };

        reader.onerror = error => {
            reject(error);
        };

        reader.readAsText(file);
    });
};

export const validateLoginLinkGeneratorFile = (file: File): Promise<boolean> => {
    return new Promise((resolve, reject) => {

        if (file.type !== 'text/csv') {
            reject(new Error('Invalid file type. Please upload a CSV file.'));
        }
        const reader = new FileReader();
        reader.onload = event => {
            if (event.target) {
                const fileContent = event.target.result as string;
                readString(fileContent, {
                    header: false,
                    dynamicTyping: true,
                    delimiter: ',',
                    skipEmptyLines: true,
                    quoteChar: '"',
                    complete: results => {
                        if (results.errors.length > 0) {
                            reject(results.errors);
                        } else {
                            const headers = (results.data as string[][])[0]
                                .filter(header => header !== null)
                                .map((header: string) => header.toLowerCase());
                            if (headers.includes('email')) {
                                if (results.data.length > MAX_RECORD_SIZE) {
                                    reject(new Error('The file contains more than 1000 records.'));
                                }

                                if (results.data.length === 1) {
                                    reject(new Error('The uploaded file cannot be empty.'));
                                } else {
                                    resolve(true);
                                }
                            } else {
                                reject(new Error(
                                    'File does not contain Email column. Please make sure the file matches the template',
                                ));
                            }
                        }
                    },
                });
            } else {
                reject(new Error('Event target is null.'));
            }
        };

        reader.onerror = error => {
            reject(error);
        };

        reader.readAsText(file);
    });
};
